import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.crops_index_page', () => {
  import('./internal/crops_index_page').then(({ default: Component }) => Component());
});
